/**
 * Onboarding step 7 — Review. A compiled summary grid of everything
 * entered (the pure model is `reviewSummary` in src/lib/onboarding.ts —
 * mirrors the forge review-then-activate feel). Honest empties render
 * as "Not provided"; nothing is invented to fill a cell.
 */

import { reviewSummary, type OnboardingDraft } from '../../../lib/onboarding';

interface Props {
  draft: OnboardingDraft;
}

export function StepReview({ draft }: Props) {
  const sections = reviewSummary(draft);
  return (
    <div className="onb-step">
      <h3 className="t-section-title onb-step__title">Review your setup</h3>
      <p className="t-meta onb-step__blurb">
        This is exactly what activation will write into your Company Brain —
        as founder-stated facts. Go back to change anything.
      </p>
      <div className="onb-review-grid">
        {sections.map((s) => (
          <div key={s.title} className="onb-review-cell">
            <div className="t-eyebrow">{s.title}</div>
            <ul className="onb-review-list">
              {s.items.map((item, i) => (
                <li
                  key={i}
                  className={item === 'Not provided' ? 'onb-review-empty' : undefined}
                >
                  {item}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
